export default "__VITE_ASSET__DwmZm4bD__"